import { assign, send, sendTo } from 'xstate';

const INITIAL_CONTEXT = {
  idle: {},
  SIGN_IN_USER: {},
  PASSWORD_RECENTLY_UPDATED: false,
};

interface DoneInvokeEvent {
  data: {
    PASSWORD_RECENTLY_UPDATED: boolean;
  };
}
// export const assignUserDataToContext = assign((ctx, event: any) => ({
//   SIGN_IN_USER: event.data?.value,
// }));

export const assignPasswordStatusToContext = assign(
  (ctx, event: DoneInvokeEvent) => ({
    PASSWORD_RECENTLY_UPDATED: event.data?.PASSWORD_RECENTLY_UPDATED ?? false,
  })
);

const MACHINE_CONFIG = {
  id: 'io.vlinder.klefki.signIn.user',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: { START: { target: 'VALIDATE_EMAIL' } },
    },
    VALIDATE_EMAIL: {
      on: { VALIDATE_EMAIL: 'CALL_VALIDATE_EMAIL' },
    },
    CALL_VALIDATE_EMAIL: {
      invoke: {
        src: 'validateEmail',
        onDone: [
          {
            target: 'VALIDATE_PASSWORD',
            cond: (_: any, event: any) => event.data.type === 'LOGIN',
            actions: ['successAction'],
          },
          {
            target: 'RENDER_SIGNUP',
            cond: (_: any, event: any) => event.data.type === 'ACCOUNT',
            actions: ['successAction'],
          },
          {
            target: 'VERIFY_OTP',
            cond: (_: any, event: any) => event.data.type === 'PASSWORD',
            actions: ['successAction'],
          },
        ],
        onError: {
          target: 'SIGN_IN_USER_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    VALIDATE_PASSWORD: {
      on: { VALIDATE_PASSWORD: 'CALL_VALIDATE_PASSWORD' },
    },
    CALL_VALIDATE_PASSWORD: {
      invoke: {
        src: 'validatePassword',
        onDone: [
          {
            target: 'RENDER_ACCOUNT_SELECTION',
            cond: (_: any, event: any) =>
              event.data.type === 'EMAIL_VERIFIED' &&
              event.data.PASSWORD_RECENTLY_UPDATED,
            actions: ['assignPasswordStatusToContext', 'successAction'],
          },
          {
            target: 'CHANGE_PASSWORD',
            cond: (_: any, event: any) =>
              event.data.type === 'EMAIL_VERIFIED' &&
              !event.data.PASSWORD_RECENTLY_UPDATED,
            actions: ['assignPasswordStatusToContext', 'successAction'],
          },
          {
            target: 'RENDER_OTP',
            cond: (_: any, event: any) =>
              event.data.type === 'EMAIL_NOT_VERIFIED',
            actions: ['assignPasswordStatusToContext', 'successAction'],
          },
        ],
        onError: {
          target: 'SIGN_IN_USER_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    RENDER_OTP: {
      on: { RENDER_OTP: 'CALL_RENDER_OTP' },
    },
    CALL_RENDER_OTP: {
      invoke: {
        src: 'validateOTP',
        onDone: [
          {
            target: 'RENDER_ACCOUNT_SELECTION',
            cond: (_: any, event: any) =>
              event.data.type === 'RENDER_ACCOUNT_SELECTION',
            actions: ['successAction'],
          },
          {
            target: 'CHANGE_PASSWORD',
            cond: (_: any, event: any) => event.data.type === 'CHANGE_PASSWORD',
            actions: ['successAction'],
          },
        ],
        onError: {
          target: 'VALIDATE_OTP_FAILED',
          actions: ['failureAction'],
        },
      },
    },

    CHANGE_PASSWORD: {
      on: { CHANGE_PASSWORD: 'CALL_CHANGE_PASSWORD' },
    },
    CALL_CHANGE_PASSWORD: {
      invoke: {
        src: 'changePassword',
        onDone: {
          target: 'RENDER_ACCOUNT_SELECTION',
          actions: ['successAction'],
        },
        onError: {
          target: 'CHANGE_PASSWORD_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    RENDER_ACCOUNT_SELECTION: {
      on: {
        GET_ACCESS_TOKEN: {
          target: 'GET_ACCESS_TOKEN',
          actions: ['successAction'],
        },
      },
    },
    GET_ACCESS_TOKEN: {
      invoke: {
        src: 'getAccessToken',
        onDone: {
          target: 'SIGN_IN_USER_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'GET_ACCESS_TOKEN_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    VERIFY_OTP: {
      on: { VERIFY_OTP: 'CALL_VERIFY_OTP' },
    },
    CALL_VERIFY_OTP: {
      invoke: {
        src: 'verifyOTP',
        onDone: {
          target: 'SET_PASSWORD',
          actions: ['successAction'],
        },
        onError: {
          target: 'VERIFY_OTP_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    SET_PASSWORD: {
      on: { SET_PASSWORD: 'CALL_SET_PASSWORD' },
    },
    CALL_SET_PASSWORD: {
      invoke: {
        src: 'setPassword',
        onDone: {
          target: 'REDIRECT_SIGNIN',
          actions: ['successAction'],
        },
        onError: {
          target: 'SET_PASSWORD_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    RENDER_SIGNUP: {
      on: { START: { target: 'VALIDATE_EMAIL' } },
    },
    SIGN_IN_USER_SUCCESS: { type: 'final' },
    REDIRECT_SIGNIN: { type: 'final' },
    SIGN_IN_USER_FAILED: { on: { START: 'VALIDATE_EMAIL' } },
    VALIDATE_OTP_FAILED: { on: { START: 'RENDER_OTP' } },
    VERIFY_OTP_FAILED: { on: { START: 'VERIFY_OTP' } },
    SET_PASSWORD_FAILED: { on: { START: 'SET_PASSWORD' } },
    GET_ACCESS_TOKEN_FAILED: { on: { START: 'VALIDATE_EMAIL' } },
    CHANGE_PASSWORD_FAILED: { on: { START: 'CHANGE_PASSWORD' } },
  },
};

// Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
